export default __webpack_public_path__ + "static/media/question_card_back.fc17849f.svg";